module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mission-permissions-table', {
    attrs: {
      "missionPermissions": _vm.missionPermissions
    }
  }), _vm._v(" "), _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionPermissionsPageCount > 1),
      expression: "missionPermissionsPageCount > 1"
    }]
  }, [_c('paginate', {
    ref: "missionPermissionsPaginate",
    attrs: {
      "pageCount": _vm.missionPermissionsPageCount,
      "clickHandler": _vm.paginateMissionPermissions,
      "container-class": 'pagination justify-content-center',
      "page-class": 'page-item',
      "page-link-class": 'page-link',
      "prev-class": 'page-item',
      "prev-link-class": 'page-link',
      "next-class": 'page-item',
      "next-link-class": 'page-link'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.refreshMissionPermissions
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.refresh')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1581da8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionPermissions.vue
// module id = 569
// module chunks = 0